import { topStory } from "@/mocks/home";

export default function TopStory() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-12">
        {/* text first */}
        <div className="flex flex-col justify-center">
          <div className="flex flex-wrap items-center gap-2">
            <span className="flex items-center gap-1.5 whitespace-nowrap rounded-sm bg-primary-500 px-2 py-1 text-xs font-semibold text-background-50">
              <i className="ri-fire-fill" />
              {topStory.badge}
            </span>
            <span className="rounded-sm bg-accent-500/90 px-2 py-1 text-xs font-medium text-foreground-950">
              {topStory.category}
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-400">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
              {topStory.meta}
            </span>
          </div>

          <h2 className="mt-5 font-heading text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-[2.7rem] md:leading-[1.25]">
            {topStory.title}
          </h2>

          <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-foreground-600">
            {topStory.summary}
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <span className="whitespace-nowrap rounded-full bg-primary-50 px-3 py-1.5 text-sm text-primary-700">
              <i className="ri-user-follow-line mr-1" />
              {topStory.read}
            </span>
            <span className="flex items-center gap-2 text-sm text-foreground-400">
              <i className="ri-chat-3-line" />
              评论区已 1.2k
            </span>
            <button
              type="button"
              className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-1.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              查看今日曝光
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>

        {/* supporting visual */}
        <div className="relative">
          <div className="overflow-hidden rounded-lg border border-background-200">
            <div className="aspect-[4/3] w-full overflow-hidden bg-background-100">
              <img
                src={topStory.image}
                alt="看黑料今日曝光 焦点事件现场图"
                title="看黑料 今日焦点现场"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="flex items-center justify-between gap-3 border-t border-background-200 bg-background-100/80 px-4 py-3">
              <span className="text-xs text-foreground-500">
                <i className="ri-time-line mr-1 text-primary-500" />
                全网同步跟进 · 已更新
                <span className="ml-1 font-display text-base text-primary-600">26</span> 次
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap text-xs font-medium text-primary-600">
                <i className="ri-eye-2-line" />
                追踪此事
              </span>
            </div>
          </div>
          <div className="pointer-events-none absolute -right-3 -top-3 -z-10 h-20 w-20 rounded-tr-lg border-r-2 border-t-2 border-primary-400" />
        </div>
      </div>
    </section>
  );
}